import React from "react";
import DateCard from "./DateCard";
import CutoffInfo from "./CutoffInfo";

/**
 * BusinessDayCard component - Display business day or next day card
 * @param {string} title - Card title
 * @param {Date} date - Date to display
 * @param {string} instance - Business day instance
 * @param {string} cutoffDate - Cutoff date
 * @param {function} formatDateTime - Function to format date and time
 * @param {string} cutoffLabel - Label for cutoff info
 * @param {React.ReactNode} children - Additional content (e.g., confirmation popup)
 */
const BusinessDayCard = ({
  title,
  date,
  instance,
  cutoffDate,
  formatDateTime,
  cutoffLabel,
  children,
  cutoffTextSize = "text-[15px]",
}) => {
  return (
    <div className="flex dark:bg-gray-700 dark:text-white dark:border-red-500 gap-2 bg-gray-50 text-center flex-col border-gray-300 rounded p-5 w-full min-w-max">
      <div className="flex flex-col items-center">
        <h2 className="font-semibold text-2xl text-center">
          {title}
        </h2>
        <div className="w-full h-[2px] bg-gray-200 my-4"></div>
        {children}
        <DateCard date={date} instance={instance} />
      </div>
      <div className="w-full h-[2px] bg-gray-200 my-4"></div>
      <CutoffInfo
        cutoffDate={cutoffDate}
        formatDateTime={formatDateTime}
        label={cutoffLabel}
        textSize={cutoffTextSize}
      />
    </div>
  );
};

export default BusinessDayCard;
